import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="cb-footer">
      <div className="cb-footer-inner">
        <div>Fast. Simple. Real-time collaboration  - </div>
        <br />
        <div>  CollabBoard </div>
      </div>
    </footer>
  );
}
